import { useEffect, useState } from "react";
import api from "./api";

export const PRICING_FALLBACK = {
  price_monthly_dkk: 399, vat_pct: 25, price_monthly_incl_vat: 498.75, trial_days: 14, due_days: 14, contact_email: "info@jatakpro.dk",
  sms_included: 150, sms_extra_ore: 50,
};

let cache = null;

export function usePricing() {
  const [p, setP] = useState(cache || PRICING_FALLBACK);
  useEffect(() => {
    if (cache) return;
    api.get("/public/pricing").then((r) => { cache = { ...PRICING_FALLBACK, ...r.data }; setP(cache); }).catch(() => {});
  }, []);
  return p;
}

export const dkk = (n) => Number(n).toLocaleString("da-DK", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
export const smsLine = (p) =>
  `${p.sms_included} SMS pr. butik pr. måned er inkluderet. Ekstra SMS ${(p.sms_extra_ore / 100).toFixed(2).replace(".", ",")} kr. ekskl. moms, kun hvis du selv slår det til. Ingen SMS i prøveperioden.`;
